import { connect } from "react-redux";
import { getDetailPhieuThuChi, getInPhieuThuChi } from "actions/InThuChi";
import InThuChi from "components/CommonComponent/InPhieuThuChi";

const mapStateToProps = (state) => ({
  inthuchi: state.inthuchi,
});

const mapDispatchToProps = (dispatch) => ({
  getDetailPhieuThuChi: (dataSearch) =>
    dispatch(getDetailPhieuThuChi(dataSearch)),
  getInPhieuThuChi: (dataSearch) => dispatch(getInPhieuThuChi(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InThuChi);
